export class ResetPasswordModel {

    public isInit: boolean = true;

    public valid: boolean = false;
    public globalError: string = null;

    public password: string = "";
    public passwordError: string = null;

}
